import styledComp from 'styled-components';
import { Colors } from '../../../../../constants';

export const Container = styledComp.div`
  width: 100%;
  position: relative;
  background-color: ${Colors.BLACK_100};
  padding-bottom: 56.25%;
`;

export const Placeholder = styledComp.div`
  color: ${Colors.WHITE_80};
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
